<template>
  <div 
      id="app" 
      style="display: flex; flex-direction: column;"> 
      <Header v-if="isAuthActive && $store.getters.getAuthResponse.read_only_customer_login === 0"/>

      <el-container style="display: flex; flex-direction: column;">
        <el-main>
          <router-view style="top: 10px; position: relative;"/>
         </el-main> 

        <br><br><br><br><br><br><br><br><br><br><br><br>
        <div style="border-top: 1px solid #000;" v-html="'&nbsp;'">

        </div>
        <el-footer v-if="$store.getters.getAuthResponse !== null && $store.getters.getAuthResponse.read_only_customer_login === 0">
          <span style="font-size: 14px;" v-html="'copyrights © '+new Date().getFullYear()+' Don Quijote Recepciones | all rights reserved'">
            
          </span>
        </el-footer>      
      </el-container>
      <el-backtop v-if="$store.getters.getAuthResponse !== null && $store.getters.getAuthResponse.read_only_customer_login === 0">
        <div style="display: flex; flex-direction: column; justify-content: center; align-items: center;">
          <span style="font-weight: bold;"><i class="el-icon-arrow-up"></i> ARRIBA</span>
        </div>
       
      </el-backtop>
       
  </div>
</template>

<script>
//import { ipcRenderer  } from "electron";
import Header from './components/Header.vue'

export default {
  components: {Header},
  data() {
    return {
    }
  },
  computed: {
    isAuthActive() {
      return this.$store.getters.isAuthenticated
    },
    getWindowObject() {
      return this.win
    },
    getAccessToken() {
      return localStorage.getItem('accessToken')        
    }
  },
  mounted() {
    if(this.isAuthActive) {
      this.$store.dispatch('tryAutoLogin')
    }
     
  }
}


</script>


<style>
body {
  font-size: 13px;
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: #383838;
  -moz-osx-font-smoothing: #383838;
  text-align: center;
  color: #383838;  
}

#app {
  width: 100wh;  
}

.rowFontSize {
  font-size: 13px;
}

.customButton {
  font-size: 14px; 
  cursor: pointer; 
  padding-left: 10px; 
  padding-right: 10px; 
  padding-top: 5px; 
  padding-bottom: 5px; 
  border: 1px solid black; 
  border-radius: 15px;
}

.customButton:hover {
  border: 1px solid orange; 
  color: orange;
}

</style>



// WEBPACK FOOTER //
// src/App.vue